import AdminGate from './AdminGate';

export default AdminGate;
